import { Container, Row, Col } from 'react-bootstrap';
import '../Global.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../components/Navbar';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import api from '../api';

function PushNotification() {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [target, setTarget] = useState('all');
  const [language, setLanguage] = useState("en");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const token = localStorage.getItem('JWTTOKEN');

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, []);

  const handleSend = async () => {
    if (!title.trim() || !body.trim()) {
      setError('Başlık ve mesaj boş bırakılamaz.');
      return;
    }

    setLoading(true);
    setResult(null);
    setError(null);

    try {
      const token = localStorage.getItem("JWTTOKEN");
      const res = await api.post('/v1/admin/push-notification/', {
        title: title.trim(),
        body: body.trim(),
        target,
        language
      }, { headers: { Authorization: `Bearer ${token}` } });

      setResult(res.data);
      setTitle('');
      setBody('');
    } catch (err) {
      setError(err?.response?.data?.message || 'Bildirim gönderilemedi.');
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    backgroundColor: '#1a1a1a',
    border: '1px solid #2a2a2a',
    borderRadius: '10px',
    color: 'white',
    padding: '12px 16px',
    width: '100%',
    outline: 'none',
    fontSize: '14px',
    transition: 'border-color 0.2s',
  };

  const labelStyle = {
    color: '#8b8b8b',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    marginBottom: '8px',
    display: 'block',
  };

  return (
    <div className="app-container">
      <Navbar />

      <div className="main-content">
        <h2 style={{ color: 'white', marginBottom: '8px' }}>Push Bildirim Gönder</h2>
        <p style={{ color: '#8b8b8b', fontSize: '14px', marginBottom: '32px' }}>
          Tüm kullanıcılara veya yalnızca premium kullanıcılara bildirim gönder.
        </p>

        <Row>
          {/* Form Kartı */}
          <Col xs={12} lg={7}>
            <div style={{
              backgroundColor: '#121212',
              border: '1px solid #252525',
              borderRadius: '16px',
              padding: '28px',
              marginBottom: '20px',
            }}>

              {/* Hedef Seçimi */}
              <div style={{ marginBottom: '24px' }}>
                <span style={labelStyle}>Hedef Kitle</span>
                <div style={{ display: 'flex', gap: '12px' }}>
                  {[
                    { value: 'all', label: 'Tüm Kullanıcılar' },
                    { value: 'premium', label: 'Yalnızca Premium' },
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      onClick={() => setTarget(opt.value)}
                      style={{
                        flex: 1,
                        padding: '10px',
                        borderRadius: '10px',
                        border: target === opt.value ? '1px solid #029220' : '1px solid #2a2a2a',
                        backgroundColor: target === opt.value ? 'rgba(2, 146, 32, 0.12)' : '#1a1a1a',
                        color: target === opt.value ? '#029220' : '#8b8b8b',
                        fontWeight: target === opt.value ? '600' : '400',
                        fontSize: '13px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: '24px' }}>
                <span style={labelStyle}>Dil Seç</span>
                <div style={{ display: 'flex', gap: '12px' }}>
                  {[
                    { value: 'en', label: 'İngilizce' },
                    { value: 'tr', label: 'Türkçe' },
                    { value: 'pl', label: 'Polonyaca' },
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      onClick={() => setLanguage(opt.value)}
                      style={{
                        flex: 1,
                        padding: '10px',
                        borderRadius: '10px',
                        border: language === opt.value ? '1px solid #029220' : '1px solid #2a2a2a',
                        backgroundColor: language === opt.value ? 'rgba(2, 146, 32, 0.12)' : '#1a1a1a',
                        color: language === opt.value ? '#029220' : '#8b8b8b',
                        fontWeight: language === opt.value ? '600' : '400',
                        fontSize: '13px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Başlık */}
              <div style={{ marginBottom: '20px' }}>
                <label style={labelStyle}>Bildirim Başlığı</label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Örn: Yeni turnuva başladı! 🏆"
                  style={inputStyle}
                  onFocus={(e) => e.target.style.borderColor = '#029220'}
                  onBlur={(e) => e.target.style.borderColor = '#2a2a2a'}
                  maxLength={100}
                />
                <div style={{ textAlign: 'right', color: '#555', fontSize: '11px', marginTop: '4px' }}>
                  {title.length}/100
                </div>
              </div>

              {/* Mesaj */}
              <div style={{ marginBottom: '28px' }}>
                <label style={labelStyle}>Mesaj</label>
                <textarea
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                  placeholder="Bildirim içeriğini buraya yaz..."
                  rows={4}
                  style={{ ...inputStyle, resize: 'vertical', lineHeight: '1.6' }}
                  onFocus={(e) => e.target.style.borderColor = '#029220'}
                  onBlur={(e) => e.target.style.borderColor = '#2a2a2a'}
                  maxLength={300}
                />
                <div style={{ textAlign: 'right', color: '#555', fontSize: '11px', marginTop: '4px' }}>
                  {body.length}/300
                </div>
              </div>

              {/* Hata Mesajı */}
              {error && (
                <div style={{
                  backgroundColor: 'rgba(220, 53, 69, 0.1)',
                  border: '1px solid rgba(220, 53, 69, 0.3)',
                  borderRadius: '10px',
                  padding: '12px 16px',
                  color: '#ff6b6b',
                  fontSize: '13px',
                  marginBottom: '20px',
                }}>
                  ⚠️ {error}
                </div>
              )}

              {/* Gönder Butonu */}
              <button
                onClick={handleSend}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '14px',
                  borderRadius: '10px',
                  border: 'none',
                  backgroundColor: loading ? '#1a3d1f' : '#029220',
                  color: loading ? '#555' : 'white',
                  fontWeight: '700',
                  fontSize: '15px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                {loading ? (
                  <>
                    <span style={{
                      width: '16px', height: '16px',
                      border: '2px solid #555',
                      borderTopColor: '#029220',
                      borderRadius: '50%',
                      display: 'inline-block',
                      animation: 'spin 0.8s linear infinite',
                    }} />
                    Gönderiliyor...
                  </>
                ) : (
                  <>🔔 Bildirimi Gönder</>
                )}
              </button>
            </div>
          </Col>

          {/* Önizleme + Sonuç */}
          <Col xs={12} lg={5}>

            {/* Önizleme */}
            <div style={{
              backgroundColor: '#121212',
              border: '1px solid #252525',
              borderRadius: '16px',
              padding: '24px',
              marginBottom: '20px',
            }}>
              <span style={labelStyle}>Önizleme</span>

              <div style={{
                backgroundColor: '#1e1e1e',
                borderRadius: '12px',
                padding: '16px',
                border: '1px solid #2a2a2a',
              }}>
                {/* iOS Bildirim Görünümü */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <div style={{
                    width: '40px', height: '40px',
                    borderRadius: '10px',
                    backgroundColor: '#029220',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '20px', flexShrink: 0,
                  }}>
                    🏆
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      color: title ? 'white' : '#555',
                      fontWeight: '600',
                      fontSize: '14px',
                      marginBottom: '4px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}>
                      {title || 'Bildirim başlığı'}
                    </div>
                    <div style={{
                      color: body ? '#c0c0c0' : '#555',
                      fontSize: '13px',
                      lineHeight: '1.4',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}>
                      {body || 'Bildirim içeriği burada görünecek...'}
                    </div>
                  </div>
                  <div style={{ color: '#555', fontSize: '11px', flexShrink: 0 }}>şimdi</div>
                </div>
              </div>

              {/* Hedef özeti */}
              <div style={{
                marginTop: '16px',
                padding: '10px 14px',
                backgroundColor: 'rgba(2, 146, 32, 0.08)',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}>
                <span style={{ fontSize: '16px' }}>{target === 'all' ? '👥' : '⭐'}</span>
                <span style={{ color: '#029220', fontSize: '13px', fontWeight: '500' }}>
                  {target === 'all' ? 'Tüm kullanıcılara gönderilecek' : 'Yalnızca premium kullanıcılara gönderilecek'}
                </span>
              </div>
            </div>

            {/* Sonuç */}
            {result && (
              <div style={{
                backgroundColor: '#121212',
                border: '1px solid #252525',
                borderRadius: '16px',
                padding: '24px',
              }}>
                <span style={labelStyle}>Gönderim Sonucu</span>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '20px',
                }}>
                  <div style={{
                    width: '48px', height: '48px',
                    borderRadius: '12px',
                    backgroundColor: 'rgba(2, 146, 32, 0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '22px',
                  }}>
                    ✅
                  </div>
                  <div>
                    <div style={{ color: 'white', fontWeight: '700', fontSize: '16px' }}>
                      Başarıyla Gönderildi
                    </div>
                    <div style={{ color: '#8b8b8b', fontSize: '13px' }}>
                      Bildirim kuyruğa alındı
                    </div>
                  </div>
                </div>

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '14px 18px',
                  backgroundColor: '#1a1a1a',
                  borderRadius: '10px',
                }}>
                  <span style={{ color: '#8b8b8b', fontSize: '13px' }}>Toplam Alıcı</span>
                  <span style={{ color: '#029220', fontWeight: '700', fontSize: '22px' }}>
                    {result.totalUsers?.toLocaleString('tr-TR')}
                  </span>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default PushNotification;